import service from '@/api/module';
import {loading, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    service: service('modules'),
    promoList: [],
    installed: [],
    loadingInstallable: false,
    installable: [],
    installationList: []
}

export const getters = {
    loadingInstallable: (state) => {
        return !!state.loadingInstallable;
    },
    installable: (state) => {
        return JSON.parse(JSON.stringify(state.installable));
    },
    promoList: (state) => {
        return JSON.parse(JSON.stringify(state.promoList));
    },
    installationList: (state) => {
        return JSON.parse(JSON.stringify(state.installationList));
    },
    installed: (state) => {
        return state.installed.map(item => item.code);
    },
    installedChecklist: (state) => {
        const list = {};

        state.installed.forEach(item => list[item.code] = true);

        return list;
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },
    'SET_PROMO_LIST': function (state, list = []) {
        state.promoList = list;
    },
    'SET_INSTALLED_LIST': function (state, list = []) {
        state.installed = list;
    },
    'SET_INSTALLABLE_LIST': function (state, list = []) {
        state.installable = list;
    },
    'SET_INSTALLATION_LIST': function (state, list = []) {
        state.installationList = list;
    },
    'SET_LOADING_INSTALLABLE': function (state, boolean = true) {
        state.loadingInstallable = boolean
    },
    'UPDATE_INSTALLABLE_LIST': function (state, item = {}) {
        const index = state.installable.findIndex(listItem => listItem.id === item.id);

        if (index !== -1) {
            state.installable[index] = item;
            state.installable = JSON.parse(JSON.stringify(state.installable));
        }
    },
    'UPDATE_INSTALLABLE_LIST_STATUS': function (state, {id, status}) {
        const index = state.installable.findIndex(listItem => listItem.id === id);

        if (index !== -1) {
            state.installable[index].is_active = status.is_active;
            state.installable[index].is_installable = status.is_installable;
            state.installable[index].is_installed = status.is_installed;
            state.installable[index].is_locked = status.is_locked;
            state.installable[index].is_waiting_for_installation = status.is_waiting_for_installation;
            state.installable[index].status = status.status;
            state.installable = JSON.parse(JSON.stringify(state.installable));
        }
    },
}

export const actions = {
    setInstalled: function ({commit}, modules) {
        commit('SET_INSTALLED_LIST', modules);
    },

    fetchInstalled: function ({commit, state, rootGetters}) {
        if (!rootGetters['user/authenticated']?.id) {
            return
        }

        loading(commit);

        return state.service.fetchInstalled().then(response => {
            commit('SET_INSTALLED_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },
    fetchPromoList: function ({commit, state}) {
        loading(commit);

        return state.service.fetchPromoList().then(response => {
            commit('SET_PROMO_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },
    installable: function ({commit, state}) {
        loading(commit);

        return state.service.fetchInstallable().then(response => {
            commit('SET_INSTALLABLE_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },
    installModule: function ({commit, state}, id) {
        loading(commit);

        return state.service.installModule(id).then(response => {
            commit('UPDATE_INSTALLABLE_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },

    uninstallModule: function ({commit, state, dispatch}, id) {
        loading(commit);

        return state.service.uninstallModule(id).then(response => {
            dispatch('fetchPromoList');
            dispatch('fetchInstalled');
            commit('UPDATE_INSTALLABLE_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },

    checkModuleStatus: function ({commit, state}, id) {
        /*loading(commit);*/

        return state.service.checkModuleStatus(id).then(response => {
            commit('UPDATE_INSTALLABLE_LIST_STATUS', {id: id, status: response.data});
            /*loading(commit, false);*/
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    },

    fetchInstallationList: function ({commit, state}, id) {
        loading(commit);

        return state.service.fetchInstallationList(id).then(response => {
            commit('SET_INSTALLATION_LIST', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit);
        });
    }
}
